import React, { useCallback, useEffect, useState } from 'react';
import Keycloak from 'keycloak-js';
import { httpClient } from '../HttpClient';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const AuthorizationHandler = ({ children }) => {

    const [authenticated, setAuthenticated] = useState(false);
    const [keycloackConfig, setKeycloackConfig] = useState(null);

    // Function to get user info from the API
    const fetchUserInfo = async (keycloak) => {
        try {
            const response = await httpClient.get(`${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/userinfo`);
            console.log('User Info from API', response.data);
        } catch (error) {
            console.error('Failed to fetch user info', error);
        }
    };


    const fetchKeycloack = async () => {
        try {
            const response = await fetch(`/keycloak.json`);
            const data = await response.json();
            setKeycloackConfig(data);
        } catch (error) {
            console.error('Failed to fetch user info', error);
        }
    };

    // const fetchEpAppData = async () => {
    //     console.log('function running -------');
    //     try {
    //         const response = await fetch(`/EPAppData.js`);
    //         const data = await response.json();
    //         console.log('EPAppData.js from API', data);
    //     } catch (error) {
    //         console.error('Failed to fetch user info', error);
    //     }
    // };

    const fetchEpAppData = async () => {
        try {
            // Dynamically load the script file
            const script = document.createElement('script');
            script.src = '/EPAppData.js';
            document.head.appendChild(script);

            // Wait for the script to load
            script.onload = () => {
                // Access the `window.epAppData` object after it's loaded
                const data = window.epAppData;
                if (data) {
                    httpClient.defaults.baseURL = data?.API_BASE_URL;
                }
            };

            // Error handling if the script fails to load
            script.onerror = () => {
                console.error('Failed to load EPAppData.js');
            };

        } catch (error) {
            console.error('Failed to fetch EPAppData.js', error);
        }
    };


    const checkAuth = useCallback(async (keycloackConfig) => {
      
        // const keycloak = new Keycloak({
        //     "realm": process.env.REACT_APP_KEYCLOACK_REALM,
        //     "url": process.env.REACT_APP_KEYCLOACK_URL,
        //     "ssl-required": "all",
        //     "clientId": process.env.REACT_APP_KEYCLOACK_CLIENTID,
        //     "public-client": process.env.REACT_APP_KEYCLOACK_PUBLIC_CLIENT,
        //     "confidential-port": process.env.REACT_APP_KEYCLOACK_CONFIDENTIAL_PORT
        // });
        const keycloak = new Keycloak(keycloackConfig);
        window.keycloak = keycloak;
        const authenticated = await keycloak.init({
            onLoad: 'login-required',
            checkLoginIframe: false,
            promiseType: 'native',
            enableLogging: true,
        });
        if (!authenticated) {
            console.log("not authenticated")
            keycloak.login();
        } else {
            setAuthenticated(authenticated)
            console.log("Authenticated");

            // Log Keycloak instance and token
            // console.log('Keycloak', keycloak);
            // console.log('Access Token', keycloak.token);

            // Retrieve and log user information from Keycloak
            const userInfo = keycloak.tokenParsed;
            // console.log('User Info', userInfo);

            // Set the Authorization header for httpClient
            httpClient.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;

            // Fetch additional user info from the API
            fetchUserInfo(keycloak);

            // Set up a token refresh interval to ensure the token is always valid
            setInterval(() => {
                keycloak.updateToken(70).then(refreshed => {
                    if (refreshed) {
                        // console.info('Token refreshed');
                        fetchUserInfo(keycloak);
                        httpClient.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;
                    } else {
                        // console.warn('Token is still valid');
                    }
                }).catch(() => {
                    // console.error('Failed to refresh token');
                    keycloak.login();  // Redirect to login if token cannot be refreshed
                });
            }, 60000);  // Check every minute (adjust based on your token TTL)

        }
    }, [])

    useEffect(() => {
        if (keycloackConfig) {
            checkAuth(keycloackConfig);
        }

    }, [checkAuth, keycloackConfig])

    useEffect(() => {
        fetchKeycloack();
        fetchEpAppData();
    }, [])



    return (
        <>
            {authenticated ? <>{children}</> : <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh", // Full viewport height
                }}
            >
                <GridLoadingSpinner />
            </div>}
        </>

    )
}

export default AuthorizationHandler